import { c as _c } from "react/compiler-runtime";
import { HotelSortViewPropertiesType } from "@website/accommodation-ui/hotel-list-header/hotel-sort-view/hotel-sort-view.types";
import { useViewPort } from "@website/hooks/viewport";
import { MaterialIcon } from "@website/icons/material";
import { ButtonPropertiesType } from "@website/ui/button";
import toString from "lodash-es/toString";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";
export const useHotelSortView = properties => {
  const $ = _c(31);
  const {
    list,
    initialValue,
    popoverProps,
    buttonProps,
    onChange,
    isNewPlP
  } = properties;
  const router = useRouter();
  const {
    isDesktop
  } = useViewPort();
  const [isDirty, setIsDirty] = useState(false);
  const [open, setOpen] = useState(false);
  const [result, setResult] = useState();
  let t0;
  let t1;
  if ($[0] !== initialValue || $[1] !== list) {
    t0 = () => {
      setResult(list.find(item => item.value === (initialValue || "selling")));
    };
    t1 = [initialValue, list];
    $[0] = initialValue;
    $[1] = list;
    $[2] = t0;
    $[3] = t1;
  } else {
    t0 = $[2];
    t1 = $[3];
  }
  useEffect(t0, t1);
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      setOpen(true);
    };
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const onClickChips = t2;
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => {
      setOpen(false);
    };
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const onClosePopover = t3;
  let t4;
  if ($[6] !== list || $[7] !== onChange) {
    t4 = response => {
      const item_0 = list.find(element => element.value === response.target.value);
      setIsDirty(true);
      setResult(item_0);
      onChange?.(item_0?.value);
      onClosePopover();
    };
    $[6] = list;
    $[7] = onChange;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const onChangeRadio = t4;
  let t5;
  if ($[9] !== initialValue || $[10] !== isDirty || $[11] !== result?.label) {
    t5 = () => toString(!isDirty && !initialValue ? "\u0645\u0631\u062A\u0628\u200C\u0633\u0627\u0632\u06CC" : !isDirty && initialValue || isDirty ? result?.label : "");
    $[9] = initialValue;
    $[10] = isDirty;
    $[11] = result?.label;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  const getLabelText = t5;
  let t6;
  if ($[13] !== getLabelText) {
    t6 = getLabelText();
    $[13] = getLabelText;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  const t7 = isNewPlP && isDesktop && process.env.NEXT_PUBLIC_APP_NAME === "villa" && router.pathname?.includes("map") ? "text" : "round-outline";
  let t8;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <MaterialIcon className="text-sm" name="sort" />;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== buttonProps || $[17] !== t6 || $[18] !== t7) {
    t9 = {
      size: "small",
      children: t6,
      variant: t7,
      StartIcon: t8,
      color: "neutral",
      onClick: onClickChips,
      ...buttonProps
    };
    $[16] = buttonProps;
    $[17] = t6;
    $[18] = t7;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  const sortButtonProps = t9;
  let t10;
  if ($[20] !== open || $[21] !== popoverProps) {
    t10 = {
      onClose: onClosePopover,
      open,
      title: "\u0645\u0631\u062A\u0628\u200C\u0633\u0627\u0632\u06CC",
      defaultHorizontalPosition: "end" as const,
      ...popoverProps
    };
    $[20] = open;
    $[21] = popoverProps;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  const t11 = result?.value;
  let t12;
  if ($[23] !== list || $[24] !== onChangeRadio || $[25] !== t11) {
    t12 = {
      list,
      checkedRadio: t11,
      onChangeRadio
    };
    $[23] = list;
    $[24] = onChangeRadio;
    $[25] = t11;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  let t13;
  if ($[27] !== sortButtonProps || $[28] !== t10 || $[29] !== t12) {
    t13 = {
      buttonProps: sortButtonProps,
      popoverProps: t10,
      radioProps: t12
    };
    $[27] = sortButtonProps;
    $[28] = t10;
    $[29] = t12;
    $[30] = t13;
  } else {
    t13 = $[30];
  }
  return t13;
};